export default __webpack_public_path__ + "static/media/veggie.72beb5b7.jpeg";